import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import FormattedCurrency from 'components/ui/FormattedCurrency';
import CurrencyInput from 'components/ui/Inputs/CurrencyInput';

import { StyledSpan } from './CashInput.styles';

const CashInput = ({
  changeDue,
  currency,
  disabled,
  name,
  onChange,
  placeHolder,
  showChange = true,
  value,
  testId,
  isCashPayment = false
}) => (
  <>
    <CurrencyInput
      currency={currency}
      disabled={disabled}
      max={1000000000}
      min={0.01}
      name={name}
      onChange={onChange}
      placeHolder={placeHolder}
      testId={testId}
      value={value}
    />
    {changeDue > 0 && showChange && !isCashPayment && (
      <StyledSpan data-cy={`${testId}-change`} data-testid={`${testId}-change`}>
        <FormattedMessage id="payments.changeDue" />: <FormattedCurrency currency={currency} amount={changeDue} />
      </StyledSpan>
    )}
  </>
);

CashInput.propTypes = {
  isCashPayment: PropTypes.bool,
  changeDue: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeHolder: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  showChange: PropTypes.bool,
  testId: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};

export default CashInput;
